import React, { useState } from "react";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comment: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 简单的表单处理
    console.log("Form submitted:", formData);
    // 可以在这里添加提交逻辑
  };

  return (
    <div className="contact">
      <div className="contact-content">
        <h1>contact</h1>
        
        <div className="contact-info">
          <p className="contact-intro">Questions, comments, or concerns? Please feel free to reach out to us:</p>
          
          <div className="contact-details">
            <h2>email</h2>
            <p><a href="mailto:mall@tunrisefield.xyz">mall@tunrisefield.xyz</a></p>
            
            <h2>mailing address</h2>
            <p>tunrisefield</p>
            <p>Valle Morelia 120</p>
            <p>Valle Soleado (FOMERREY-107)</p>
            <p>67114 Guadalupe, N.L., MX</p>
          </div>
        </div>
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Name"
                className="form-input"
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email *"
                className="form-input"
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <textarea
              id="comment"
              name="comment"
              value={formData.comment}
              onChange={handleInputChange}
              placeholder="Comment"
              className="form-textarea"
              rows={4}
            ></textarea>
          </div>
          
          <button type="submit" className="submit-button">
            Send
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
